import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, Typography,} from "@mui/material";
import SouffletsAnalyse from "./final/SouffletsAnalyse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Synthese from "./Synthese";
import {correctId, correctName, getColor, tddDelay} from "../Utils";

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import MapBvs from "./final/maps/MapBvs";
import {useStyles} from "../Style";
import PrintIcon from "@mui/icons-material/Print";
import Checkbox from '@mui/material/Checkbox';
import generatePDF, {Margin, Resolution, usePDF} from "react-to-pdf";
import {useState} from "react";
import {CheckBox} from "@mui/icons-material";
import {PDFExport} from "@progress/kendo-react-pdf";
import PdfIcon from '@mui/icons-material/PictureAsPdf';

export default function BVSoufflet({
                                       bv,
                                       k,
                                       rangInscrit,
                                       rangAbstention,
                                       resultsByBvsSynthese,
                                       resultsGeomByBvsSynthese,
                                       resultsGeomIrisByBvsSynthese,
                                       resultsByIris,
                                       resultsByBvs,
                                       resultsParCandidatsByBvs,
                                       resultsParDonneesInseeByBvs,
                                       codeInsee,
                                       showPersonae,
                                       filterBvTmp,
                                       mappingBvArrondissement,
                                       listOfAddress,
                                       otherResults,
                                       border,
                                       electionType
                                   }) {

    const [opened, setOpened] = React.useState(false);

    const [print, setPrint] = React.useState(null);
    const [forceOpen, setForceOpen] = React.useState(false);
    const [forceClose, setForceClose] = React.useState(false);
    let targetRef = React.createRef();

    const pdfExportComponent = React.useRef(null);
    const exportPDFWithMethod = () => {
        pdfExportComponent.current.save();
    };

    function getNumberInAddresse(listOfAddress1) {
        if (listOfAddress1.numeros.length === 0) {
            return ""
        } else {
            let sorted = listOfAddress1.numeros.sort((a, b) => {
                return a - b
            });
            return "(" + sorted[0] + " à " + sorted[sorted.length - 1] + ")";
        }

    }

    return (
        <PDFExport scale={0.3} margin="0.8cm" forcePageBreak=".page-break2" ref={pdfExportComponent}
                   paperSize="A4"
                   fileName={bv.key + '.pdf'}>
            <Accordion

                id={bv.key}
                key={bv.key}
                sx={{width:"98%",borderLeft: "30px solid " + getColor(bv.color), mb: 2}}
                ref={targetRef}
            >
                <AccordionSummary
                    sx={{width:"100%"}}
                    expandIcon={
                        <IconButton
                            component="div"
                            sx={[useStyles.main.container.accordion.icon,]}>
                            <ExpandMoreIcon/>
                        </IconButton>}
                    onClick={() => {
                        setOpened(!opened)
                    }}>
                    <Box sx={{width: "95%", display: "flex", flexDirection: "column"}}>
                        <Typography variant="h5" sx={{}}>
                            {(bv.name).toUpperCase()} : BV N°{bv.bvIdText}
                        </Typography>
                        <Synthese
                            electionType={electionType}
                            border={border}
                            results={bv.results}
                            codeInsee={codeInsee}
                            stats={{
                                inscrit: {
                                    nb: bv.inscrit.nb,
                                    rang: rangInscrit,
                                    percent: bv.inscrit.perc
                                },
                                abstention: {
                                    nb: bv.abstention.result,
                                    rang: rangAbstention,
                                    percent: bv.abstention.perc
                                }
                            }}
                        />
                    </Box>
                </AccordionSummary>
                {opened && <AccordionDetails>
                    <Button
                        component="div"
                        sx={{
                            textAlign: "center",
                            background: "rgb(255,137,137)",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "rgb(241,56,56)"
                            },
                        }}
                        onClick={() => {
                            setPrint(bv.key)
                            setForceOpen(true)
                            setTimeout(() => {
                                exportPDFWithMethod();
                                tddDelay(800).then(() => {
                                    setPrint(null)
                                    setForceOpen(false)
                                    setForceClose(true)
                                    tddDelay(800).then(() => {
                                        setForceClose(false)
                                    });
                                });

                            }, 1000);

                        }}>

                        <Typography sx={{display: "flex"}}>
                            <PdfIcon/>Export</Typography>
                    </Button>
                    <MapBvs
                        resultsByBvsSynthese={resultsByBvsSynthese}
                        resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                        resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                        resultsByIris={resultsByIris}
                        visible={opened}
                        filterBv={filterBvTmp}
                        filterIris={[]}
                        filterStatus={[]}
                        selectedBv={bv.key}
                        mappingBvArrondissement={mappingBvArrondissement}

                    />
                    {print === bv.key && <Box sx={{
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        alignItems: "center"
                    }}>
                        {Object.keys(listOfAddress).map((address, index) => {
                            return (<Box key={index} sx={{
                                display: "flex",
                                flexDirection: "row",
                                width: 450,
                                alignItems: "center"
                            }} key={index}>
                                <Checkbox/>
                                <Typography>{listOfAddress[address].addresse} {getNumberInAddresse(listOfAddress[address])}</Typography>
                                <Box sx={{mb: 1}}/>
                            </Box>)
                        })}

                    </Box>}
                    <SouffletsAnalyse
                        resultats={resultsByBvs[bv.key]}
                        resultsParCandidatsNuancesCommune={resultsParCandidatsByBvs[bv.key]}
                        data={resultsParDonneesInseeByBvs[k]?resultsParDonneesInseeByBvs[k]:resultsParDonneesInseeByBvs[bv.key]}
                        showPersonae={showPersonae}
                        resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                        forceOpen={forceOpen}
                        forceClose={forceClose}
                        otherResults={otherResults[bv.key]}
                        showIris={true}
                        bvId={bv.key}
                    />
                </AccordionDetails>}
            </Accordion>
        </PDFExport>)

}
/*



 */
